import { Table, Modal, Spin, Button, Switch, Tag, Tabs, Tooltip } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { getColumnSearchProps } from "../../../utils/tables";
import Header from "../../../components/HeaderList";
import Editor from "./Editor";
import styles from "../styles/FrontpageUI.module.css";

const { TabPane } = Tabs;

const FrontpageUI = (props) => {
  const {
    initialFetch,
    loading,
    editorVisible,
    editBanner,
    newBanner,
    closeEditor,
    banner,
    handleBanner,
    banners,
    handleActive,
    confirmDelete,
    isBannerOrPopUp,
    products,
    categories,
    changeTable,
    modals,
  } = props;

  const getPlatformTag = (val) => {
    if (val === "WEB") return <Tag className={styles.tagWeb}>Sitio Web</Tag>;
    if (val === "APP") return <Tag className={styles.tagApp}>App Móvil</Tag>;
    if (val === "KIOSCO") return <Tag className={styles.tagKiosco}>Kiosco</Tag>;
    return val;
  };

  const getActionTag = (val) => {
    const labels = {
      NONE: "Ninguna",
      PRODUCT: "Producto",
      CATEGORY: "Categoría",
      MODAL: "Modal",
      EXTERNAL: "URL Externa",
    };
    const colors = {
      NONE: "default",
      PRODUCT: "blue",
      CATEGORY: "green",
      MODAL: "purple",
      EXTERNAL: "cyan",
    };
    return <Tag color={colors[val] || "default"} className={styles.tagAction}>{labels[val] || val}</Tag>;
  };

  const columns = [
    {
      title: "Banner",
      dataIndex: "image",
      width: 220,
      render: (val) => (
        <div className={styles.banner}>
          <img src={val} alt="Banner preview" />
        </div>
      ),
    },
    {
      title: "Nombre",
      dataIndex: "name",
      ...getColumnSearchProps("name"),
    },
    {
      title: "Plataforma",
      dataIndex: "mode",
      align: "center",
      filters: [
        { text: "Sitio Web", value: "WEB" },
        { text: "App móvil", value: "APP" },
        { text: "Kiosco", value: "KIOSCO" },
      ],
      filterMultiple: false,
      onFilter: (value, record) => record.mode === value,
      render: (val) => getPlatformTag(val),
    },
    {
      title: "Tipo Acción",
      dataIndex: "action_type",
      align: "center",
      render: (val) => getActionTag(val),
    },
    {
      title: "Activo",
      align: "center",
      dataIndex: "status",
      filters: [
        { text: "Activo", value: 1 },
        { text: "Inactivo", value: 0 },
      ],
      filterMultiple: false,
      onFilter: (value, record) => record.status === value,
      render: (val, record) => (
        <Switch
          className={styles.activeSwitch}
          checked={val}
          onChange={() => isBannerOrPopUp === "banner" ? handleActive(record.id, val) : ""}
        />
      ),
    },
    {
      title: "Acciones",
      align: "center",
      dataIndex: "id",
      render: (id, record) => (
        <div className={styles.actions}>
          <Tooltip title="Editar">
            <Button
              type="text"
              icon={<EditOutlined />}
              className={styles.editBtn}
              onClick={() => editBanner(record)}
            />
          </Tooltip>
          <Tooltip title="Eliminar">
            <Button
              type="text"
              icon={<DeleteOutlined />}
              className={styles.deleteBtn}
              onClick={() => confirmDelete(id)}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  const tabContent = (dataSource) => (
    !loading ? (
      <Table columns={columns} dataSource={dataSource} rowKey="id" scroll={{ x: 'max-content' }} />
    ) : (
      <div className={styles.loader}>
        <Spin size="large" />
      </div>
    )
  );

  return (
    <div className={styles.wrapper}>
      <Header
        title="Portada"
        actions={
          <div className={styles.headerActions}>
            <Button
              icon={<PlusOutlined />}
              size="large"
              className={styles.newButton}
              onClick={() => newBanner(isBannerOrPopUp)}
              style={{ display: 'inline-flex', alignItems: 'center', gap: '0.375rem' }}
            >
              {isBannerOrPopUp === "banner" ? "NUEVO BANNER" : "NUEVO POPUP"}
            </Button>
          </div>
        }
      />

      <Tabs
        activeKey={isBannerOrPopUp}
        onChange={(key) => changeTable(key)}
        className={styles.tabsContainer}
        size="large"
      >
        <TabPane tab="Banners" key="banner">
          {tabContent(banners)}
        </TabPane>
        <TabPane tab="Popups" key="popup">
          {tabContent(modals)}
        </TabPane>
      </Tabs>

      <Modal
        destroyOnClose
        visible={editorVisible}
        footer={false}
        closable={false}
        width={700}
        onCancel={closeEditor}
        centered
        bodyStyle={{ maxHeight: '85vh', overflowY: 'auto' }}
      >
        <Editor
          initialFetch={initialFetch}
          banner={banner}
          closeEditor={closeEditor}
          handleBanner={handleBanner}
          isBannerOrPopUp={isBannerOrPopUp}
          products={products}
          categories={categories}
        />
      </Modal>
    </div>
  );
};

export default FrontpageUI;